export default "__VITE_ASSET__Bev8oSxc__"